import { useParams } from 'react-router-dom';

import store from '../redux/store';

import TasksDeserventi from './rsvti/deserventi/TasksDeserventiComponent';
import TaskDeserventiCouponStampNew from './rsvti/deserventi/TaskCouponStampRenewalNewComponent';
import TaskDeserventiCouponStampManagement from './rsvti/deserventi/TaskCouponStampRenewalManagementComponent';
import TaskDeserventiCertificateNew from './rsvti/deserventi/TaskCertificateRenewalNewComponent';
import TaskDeserventiCertificateManagement from './rsvti/deserventi/TaskCertificateRenewalManagementComponent';

import { RefreshTasksCachedData, RefreshEmployersByCIDCachedData, RefreshEmployersByEIDCachedData, RefreshClientsCachedData } from './AFStoreDataRefresh';
import * as AFStateHelper from './AFStateHelper';
import { DispatchAF } from './AFStoreDispatchAction';
import * as Security from '../utils/auth/Security';
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';


export const TasksDeserventiPage = () => {
    const reduxStore = store.getState();

    var dataStatus;
    if( reduxStore.clients.status === ReduxDataStatus.LOADING || reduxStore.clients.status === ReduxDataStatus.IDLE ) {
        
        dataStatus = ReduxDataStatus.LOADING;
    }
    else {
        dataStatus = ReduxDataStatus.SUCCEEDED;
    }

    return (
        <TasksDeserventi 
            loadComponentData={RsvtiTasksDataLoader}
            dataStatus={dataStatus}
            rsvtiTasks={reduxStore.rsvtiTasks}
            clients={reduxStore.clients.clients}
        />
    );
}

const RsvtiTasksDataLoader = () => {
    console.log('++++ RsvtiTasksDataLoader <<')
    RefreshClientsCachedData();
    var taskClientId;
    if(Security.isUserOfClientEmployer()) {
        taskClientId = AFStateHelper.getSiuClientEmployerRsvtiServiceProvider();
    }
    else{
        taskClientId = AFStateHelper.getContextClientId();
    }

    RefreshTasksCachedData(taskClientId);
}


export const TaskDeserventiCouponStampNewPage = () => {
    const reduxStore = store.getState();

    return (
        <TaskDeserventiCouponStampNew 
            postRsvtiTask={DispatchAF.postRsvtiTask}
            mostRecentTaskId={reduxStore.bucket.bucket.mostRecentTaskId}
            dataStatus={reduxStore.rsvtiTasks.status}
        />
    );
}

export const TaskDeserventiCouponStampManagePage = () => {
    const reduxStore = store.getState();

    let {taskId} = useParams();
    const ctId = parseInt(taskId, 10)

    return (
        <TaskDeserventiCouponStampManagement 
            loadComponentData={RsvtiTaskManageDataLoader}
            rsvtiTask={reduxStore.rsvtiTasks.tasks.filter((task) => task.id === ctId)[0]}
            dataStatus={reduxStore.rsvtiTasks.status}
            patchRsvtiTask={DispatchAF.patchRsvtiTask}
            patchAuthzsStampDate={DispatchAF.patchAuthzsStampDate}
            employers={reduxStore.employers.employers}
        />
    );
}


const RsvtiTaskManageDataLoader = () => {
    console.log('++++ RsvtiTaskManageDataLoader <<')

    RefreshClientsCachedData();
    // var taskClientId;
    if(Security.isUserOfClientEmployer()) {
        const taskClientId = AFStateHelper.getSiuClientEmployerRsvtiServiceProvider();
        const myEmployerId = AFStateHelper.getSiuClientEmployerEID();

        // Refresh the tasks in case the user navigates to this task from Calendar
        RefreshTasksCachedData(taskClientId);

        RefreshEmployersByEIDCachedData(myEmployerId);

    }
    else{
        const taskClientId = AFStateHelper.getContextClientId();

        // Refresh the tasks in case the user navigates to this task from Calendar
        RefreshTasksCachedData(taskClientId);

        RefreshEmployersByCIDCachedData(taskClientId);
    }
}


export const TaskDeserventiCertificateNewPage = () => {
    const reduxStore = store.getState();

    return (
        <TaskDeserventiCertificateNew 
            postRsvtiTask={DispatchAF.postRsvtiTask}
            mostRecentTaskId={reduxStore.bucket.bucket.mostRecentTaskId}
            dataStatus={reduxStore.rsvtiTasks.status}
        />
    );
}

export const TaskDeserventiCertificateManagePage = () => {
    const reduxStore = store.getState();

    let {taskId} = useParams();
    const ctId = parseInt(taskId, 10)

    return (
        <TaskDeserventiCertificateManagement 
            loadComponentData={RsvtiTaskManageDataLoader}
            rsvtiTask={reduxStore.rsvtiTasks.tasks.filter((task) => task.id === ctId)[0]}
            dataStatus={reduxStore.rsvtiTasks.status}
            patchDeserventiTask={DispatchAF.patchRsvtiTask}
            patchAuthzsCertDate={DispatchAF.patchAuthzsCertDate}
            employers={reduxStore.employers.employers}
        />
    );
}
